export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20warm%20gradient%20background%20with%20soft%20glowing%20orb%20in%20the%20center%20right%2C%20deep%20burgundy%20and%20charcoal%20tones%2C%20atmospheric%20depth%2C%20modern%20editorial%20design%2C%20subtle%20grain%20texture%2C%20minimalist%20composition%20with%20negative%20space%2C%20warm%20amber%20accents%2C%20cinematic%20lighting%2C%20no%20text%20or%20logos&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="黑料网站背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
              <i className="ri-fire-line text-primary-300 text-sm"></i>
              <span className="text-xs font-semibold text-primary-200 tracking-wide whitespace-nowrap">实时热门爆料 · 每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
              黑料网站
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-normal text-white/80 mt-3">
                网红娱乐圈黑料实时聚合平台
              </span>
            </h1>

            <p className="text-lg md:text-xl font-medium text-white/75 mt-4 mb-2">
              吃瓜第一线，爆料不等待
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl mx-auto lg:mx-0 mt-5">
              汇集吃瓜黑料网站、51黑料网站、91黑料网站及网红黑料网站推荐合集，
              每日追踪全网最新热门黑料网站列表，覆盖明星八卦、网红翻车、娱乐圈内幕等多元内容。
              本站为黑料网站大全导航平台，持续收录优质吃瓜资源，方便用户快速定位特定来源，
              一站掌握全网最火吃瓜动态。
            </p>

            <div className="flex flex-wrap items-center gap-6 mt-8 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-white/70">
                <i className="ri-global-line text-accent-400 text-lg"></i>
                <span className="text-sm whitespace-nowrap">覆盖200+ 黑料来源</span>
              </div>
              <div className="flex items-center gap-2 text-white/70">
                <i className="ri-timer-flash-line text-accent-400 text-lg"></i>
                <span className="text-sm whitespace-nowrap">每日实时更新</span>
              </div>
              <div className="flex items-center gap-2 text-white/70">
                <i className="ri-shield-check-line text-accent-400 text-lg"></i>
                <span className="text-sm whitespace-nowrap">严格来源筛选</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 justify-center lg:justify-start">
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索热门话题
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full backdrop-blur-sm border border-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-list-check-2 text-lg"></i>
                查看黑料索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20editorial%20illustration%20depicting%20digital%20news%20aggregation%20and%20social%20media%20buzz%2C%20warm%20coral%20and%20amber%20color%20palette%20on%20dark%20background%2C%20overlapping%20semi-transparent%20geometric%20shapes%20representing%20information%20flow%2C%20modern%20magazine-style%20composition%2C%20clean%20minimalist%20aesthetic%2C%20no%20text%2C%20cinematic%20lighting&width=800&height=1000&seq=hero-visual-2026&orientation=portrait"
                alt="黑料网站主视觉 - 网红娱乐圈爆料聚合"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}